<script>
  import { currentPage, totalPages, collectionProducts, productCount } from "./stores/collection-products-store";
</script>

{#if $totalPages > $currentPage}
  <div class="flex items-center flex-col my-5 text-brand-blue">
    <p class="text-b2 mb-m">Viewing {$collectionProducts.length} of {$productCount} products</p>
    <button on:click={() => currentPage.set(++$currentPage)} class="btn btn--outline btn--blue">
      Load more
    </button>
  </div>
{/if}